<template>
  <div
    class="wecoupon-coupon-item"
    :class="[`wecoupon-coupon-item-${couponInfo.state}`]"
    v-if="couponInfo"
    @click="handleClick"
    v-stat.click="{
      tag: 'wecoupon_module.coupons_click|点击优惠券',
      ext: {
        fcouponid: couponInfo.couponId,
        fspid: couponInfo.spId,
        fstate: couponInfo.state,
        ...getBiExt,
      },
    }"
    v-stat.brow_mult="{
      tag: 'wecoupon_module.coupons_views|wecoupons-组件-浏览优惠券',
      ext: {
        fcouponid: couponInfo.couponId,
        fspid: couponInfo.spId,
        fstate: couponInfo.state,
        ...getBiExt,
      },
    }"
  >
    <div class="new" v-show="couponInfo.isNew">{{ i18n('最新') }}</div>
    <div class="picture" role="button" :aria-label="couponAriaLabel">
      <img
        v-if="couponInfo.goodsUrl"
        :src="couponInfo.goodsUrl"
        alt=""
        />
    </div>
    <div class="content">
      <div role="button" :aria-label="couponAriaLabel">
        <div class="merchant-info">
          <img v-if="spLogo" :src="spLogo" />
          <i>{{ spName }}</i>
        </div>
        <div class="coupon-name">{{ couponInfo.couponName }}</div>
      </div>
      <div class="coupon-value-btn">
        <div class="coupon-value"  aria-hidden="true">
          <i
            class="off-value"
            :aria-label="`${couponValue.value}${i18n('折')}`"
            v-if="couponValue.isOff"
          >
            <i>{{ couponValue.value }}</i
            ><span>{{ i18n('折') }}</span>
          </i>
          <CouponAmount
            v-else
            :currencyType="couponInfo.currencyType"
            :prizeAmountYuan="couponValue.value"
            :size="amountSize"
            :zoomRatio="0.8">
          </CouponAmount>
        </div>
        <CouponBtn
          :state="couponInfo.state"
          @click="handleBtnClick"
          v-stat.click="{
            tag: 'wecoupon_module.coupons_redeem_click|组件点击按钮',
            ext: {
              fstate: couponInfo.state,
              fcouponid: couponInfo.couponId,
              fspid: couponInfo.spId,
              freceiveentry: couponEntry + 'List',
              ...getBiExt,
            },
          }"
        ></CouponBtn>
      </div>
      <div class="coupon-tips" v-if="couponTips">{{ couponTips }}</div>
    </div>
    <CouponStamp
      :state="couponInfo.state"
      class="coupon-item-stamp"
    ></CouponStamp>
    <CouponDetail
      v-if="isShowDetail"
      ref="detail"
      :couponInfo="couponInfo"
      @close="handleDetailClose"
      @btnClick="handleDetailBtnClick"
      @shareClick="handleDetailShareClick"
      @action="notifyActionHalfDialog"
      :isShowSuccToast="isShowSuccToast"
      :classId="classId"
      :isShowShare="isShowShare"
      :couponEntry="couponEntry"
    >
      <div slot="merchant-info">
        <slot></slot>
      </div>
    </CouponDetail>
  </div>
</template>

<script lang="ts">
import { to } from '@tencent/wphk-base-utils';
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { getCoupon, getCouponStateText, getCouponTips, getCouponValue } from './business';
import { CouponEntryReportInfo, CouponInfo, CouponState } from '../../type';
import { showDialog } from '@tencent/wphk-components-dialog';
import { i18n } from '../../i18n';
import { showLoading, hideLoading } from '@tencent/wphk-components-loading';
import CouponDetail from './detail.vue';
import CouponStamp from './stamp.vue';
import CouponBtn from './button.vue';
import { showToast } from '@tencent/wphk-components-toast';
import { getJumpPageABTestInfo } from '../../business';
import { goCouponDetail } from '../../business/coupon';
import { parseCurrencyAria, CouponAmount, getCurrencyCodeByType } from '@tencent/wphk-act-base-ui';
/**
 * 券展示单项
 * 主要功能：领取状态、领取、展示券详情、「NEW」标识
 */
@Component({
  components: {
    CouponDetail,
    CouponStamp,
    CouponBtn,
    CouponAmount,
  },
})
export default class WeCouponsCouponItem extends Vue {
  @Ref('detail') couponDetail!: CouponDetail;
  /**
   * 券信息
   */
  @Prop() public data!: CouponInfo;
  /**
   * 金额size设置
   */
  @Prop({ default: 48 }) public amountSize!: number;
  /**
   * 点击券是否展示详情
   */
  @Prop({ default: true }) public isDisplayDetail!: boolean;

  /**
   * 是否展示券状态印记
   */
  @Prop({ default: true }) public isDisplayStamp!: boolean;

  /**
   * 是否领取后是否立刻更新券状态
   */
  @Prop({ default: true }) public isUpdateState!: boolean;
  /**
   * 是否展示领取成功 toast，默认展示
   */
  @Prop({ default: true }) isShowSuccToast!: boolean;

  /** 是否点击无效 */
  @Prop({ default: false }) disabled?: boolean;

  /** 是否在详情点击领取后执行emit事件 */
  @Prop({ default: true }) notifyFromDetailAfterGetCoupon?: boolean;

  /** 是否在关闭详情后判断状态，如果是已领取则执行emit事件 */
  @Prop({ default: false }) notifyAfterGetCouponAndClose?: boolean;

  /** 当前组件所处的分类 */
  @Prop() classId?: string;
  /** 是否展示分享入口 */
  @Prop() isShowShare?: boolean;
  /** 券入口上报信息 */
  @Prop({ default: () => ({}) }) couponEntryReportInfo!: CouponEntryReportInfo;

  i18n = i18n;

  // 券数据
  couponInfo: CouponInfo | null = null;
  isShowDetail = false;

  /**
   * bi ext
   */
  get getBiExt() {
    const { col, row } = this.couponEntryReportInfo;
    return {
      frow: row,
      fcol: col,
      fclassid: this.classId,
      ...getJumpPageABTestInfo(),
    };
  }
  get couponEntry() {
    return this.couponEntryReportInfo.entry || 'default';
  }

  /**
   * 获取领取按钮信息
   */
  get state() {
    const state = this.couponInfo?.state || CouponState.Empty;
    return {
      desc: getCouponStateText(state),
      disable: state !== CouponState.Normal,
    };
  }

  get couponAriaLabel() {
    const { couponValue } = this;
    const amount = couponValue.isOff ? `${couponValue.value}${i18n('折')}` : `${getCurrencyCodeByType(this.couponInfo?.currencyType)}${couponValue.value}`;
    return parseCurrencyAria(`${this.spName} ${this.couponInfo?.couponName} ${amount}`, false, this.couponInfo?.currencyType);
  }

  /**
   * 获取券提示信息
   */
  get couponTips() {
    return getCouponTips(this.couponInfo!);
  }

  /**
   * 获取金额信息
   */
  get couponValue() {
    return getCouponValue(this.couponInfo!.couponValue);
  }

  /**
   * 商户logo
   */
  get spLogo() {
    return this.couponInfo?.merchantInfo.spLogo;
  }
  /**
   * 商户名
   */
  get spName() {
    return this.couponInfo?.merchantInfo.spName;
  }

  /**
   * 券点击
   */
  handleClick() {
    this.$emit('click');
    if (!this.isShowDetail && this.isDisplayDetail) {
      this.isShowDetail = true;
      setTimeout(() => {
        if (this.couponDetail) {
          this.couponDetail.show(this.couponInfo!);
        }
      }, 100);
    }
  }

  /**
   * 关闭详情
   */
  handleDetailClose() {
    this.isShowDetail = false;
    // emit通用关闭couponDetail事件
    this.notifyAction('closeCouponDetail', this.couponInfo);
    // 针对领取成功emit 领取成功且关闭couponDetail事件
    if (this.couponInfo?.state === CouponState.Got && this.notifyAfterGetCouponAndClose) {
      this.notifyAction('getSuccAndCloseCouponDetail', {
        err: null,
        result: {
          form: 'detailClose',
          couponId: this.couponInfo.couponId,
          recvState: 0,
          userScid: '',
        },
      });
    }
  }
  /** 弹窗中领取后进行emit */
  notifyActionHalfDialog(name, data) {
    if (!this.notifyFromDetailAfterGetCoupon) {
      return;
    }
    this.notifyAction(name, data);
  }
  /**
   * 详情中的按钮点击
   */
  handleDetailBtnClick() {
    this.handleBtnClick();
  }

  /**
   * 详情中的分享点击
   */
  handleDetailShareClick() {
    this.$emit('shareClick');
  }

  created() {
    this.couponInfo = this.data;
  }

  /**
   * 通知调用方领券结果
   */
  notifyAction(name: string, data) {
    this.$emit('action', { name, data });
  }

  /**
   * 领券
   */
  async getCoupon() {
    const spId = this.couponInfo?.merchantInfo?.spId || '';
    const couponId = this.couponInfo?.couponId || '';
    showLoading();
    const [err, result] = await to(getCoupon(spId, couponId));
    hideLoading();
    this.notifyAction('getCoupon', { err, result });
    if (err) {
      return showDialog({
        title: i18n('領取失敗，請稍候再試'),
      });
    }
    if (this.isShowSuccToast) {
      showToast({
        title: i18n('領取成功'),
        duration: 1000,
      });
    }
    // 领取成功，更新状态
    if (this.couponInfo && this.isUpdateState) {
      this.couponInfo.state = CouponState.Got;
      this.couponInfo.userScid = result?.userScid || '';
    }
  }

  /**
   * 点击券按钮
   */
  async handleBtnClick() {
    if (this.disabled) {
      return;
    }
    this.$emit('btnClick');
    switch (this.couponInfo?.state) {
      case CouponState.Normal:
        return await this.getCoupon();
      case CouponState.Got:
        goCouponDetail(this.couponInfo?.type, {
          userScid: this.couponInfo.userScid,
          adtag: 'discount-center',
        });
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../less/main.less';
.wecoupon-coupon-item {
  width: 335 / @rem;
  min-height: 388 / @rem;
  background: #ffffff;
  border-radius: 16 / @rem;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0.02rem 0.02rem rgba(0, 0, 0, 0.1);
  .new {
    // min-width: 60 / @rem;
    min-height: 31 / @rem;
    padding: 0 8 / @rem;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    background: #fa9d3b;
    font-family: 'PingFang HK';
    font-style: normal;
    font-weight: 400;
    font-size: 22 / @rem;
    line-height: 31 / @rem;
    text-align: center;
    color: #ffffff;
    border-top-left-radius: 8 / @rem;
    border-bottom-right-radius: 8 / @rem;
  }
  .picture {
    width: 100%;
    // background-color: #dedede;
    height: 180 / @rem;
    position: relative;
    overflow: hidden;
    padding: 0;

    padding: 4/rem 4/rem 0 4/rem;
    box-sizing: border-box;

    img {
      width: 100%;
      border-top-left-radius: 16 / @rem;
      border-top-right-radius: 16 / @rem;
      border-radius: 100% 100% 100% 100% / 0% 0% 30% 30%;
    }
    &::after {
      content: ' ';
      position: absolute;
      left: 0;
      bottom: -4 / @rem;
      right: 0;
      z-index: 1;
      width: 335 / @rem;
      height: 40 / @rem;
      background-image: url(./assets/img-bg.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: 0;
    }
  }
  .content {
    margin: 24 / @rem;
    .merchant-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        height: 48 / @rem;
        width: 48 / @rem;
        background: #ffffff;
        border: 1px solid #e6e6e6;
        border-radius: 50%;
        margin-right: 8 / @rem;
      }
      i {
        font-size: 24 / @rem;
        color: #1a1a1a;
        opacity: 0.9;
        font-style: normal;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .coupon-name {
      font-size: 28 / @rem;
      color: rgba(0, 0, 0, 0.9);
      margin-top: 8 / @rem;
      line-height: 40 / @rem;
      // text-overflow: ellipsis;
      // overflow: hidden;
      // white-space: nowrap;
    }

    .coupon-value-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 16 / @rem;
      .coupon-value {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-style: normal;
        font-weight: 500;
        font-size: 48 / @rem;
        line-height: 53 / @rem;
        .amount-medium;
        text-align: justify;
        color: #fa5151;
        position: relative;
        display: inline-block;
        .value {
          padding-left: 40 / @rem;
          font-style: normal;
          &::before {
            top: 0;
            left: 0;
            position: absolute;
            z-index: 1;
            content: 'HK$';
            font-size: 20 / @rem;
            line-height: 30 / @rem;
            font-family: inherit;
          }
        }
        .off-value {
          display: inline-block;
          position: relative;
          i {
            font-style: normal;
          }
          span {
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 400;
            font-size: 22 / @rem;
            width: 30 / @rem;
            display: inline-block;
            line-height: 22 / @rem;
          }
        }
      }
    }
    .coupon-tips {
      border-top: 2 / @rem dashed #f2f2f2;
      margin-top: 16 / @rem;
      font-family: 'PingFang HK';
      font-style: normal;
      font-weight: 400;
      font-size: 22 / @rem;
      line-height: 31 / @rem;
      padding: 5 / @rem 0;
      color: #808080;
    }
  }
  .coupon-item-stamp {
    position: absolute;
    z-index: 1;
    bottom: -32 / @rem;
    right: -18 / @rem;
  }
}
</style>

